import React from "react";
import { useEstatisticasProducao } from "../context/EstatisticasProducaoContext";
import { UsuarioRanking } from "../../../../services/producaoService";

const Ranking: React.FC = () => {
  const { ranking, isLoading, getCorPorIndice } = useEstatisticasProducao();

  if (isLoading) {
    return (
      <div className="rounded-lg bg-white p-6 shadow">
        <h3 className="mb-4 text-lg font-medium text-neutral-900">
          Ranking de Produção
        </h3>
        <div className="py-8 text-center">
          <p className="text-neutral-500">Carregando...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="rounded-lg bg-white p-6 shadow">
      <h3 className="mb-4 text-lg font-medium text-neutral-900">
        Ranking de Produção
      </h3>

      {ranking.length === 0 ? (
        <div className="py-8 text-center">
          <p className="text-neutral-500">
            Nenhum dado encontrado para o período selecionado.
          </p>
        </div>
      ) : (
        <div className="space-y-3">
          {ranking.map((usuario: UsuarioRanking, index: number) => (
            <div
              key={usuario.usuarioId}
              className="flex items-center justify-between rounded-lg bg-neutral-50 p-3"
            >
              <div className="flex items-center">
                <div
                  className={`flex h-8 w-8 items-center justify-center rounded-full text-sm font-bold text-white ${getCorPorIndice(index)}`}
                >
                  {index + 1}
                </div>

                <div className="ml-3">
                  <p className="font-semibold text-neutral-900">
                    {usuario.nome}
                  </p>
                </div>
              </div>

              <div className="flex items-center gap-6">
                <div className="text-right">
                  <p className="text-sm font-medium text-neutral-900">
                    {usuario.quantidadePizzas}
                  </p>
                  <p className="text-xs text-neutral-500">Pizzas</p>
                </div>
                <div className="text-right">
                  <p className="text-sm font-medium text-neutral-900">
                    {usuario.tempoMedio}
                  </p>
                  <p className="text-xs text-neutral-500">Tempo médio</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Ranking;
